import { useCallback } from 'react';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { moveToSearchResultPage } from '../logics/moveToSearchResultPage';

/**
 * 検索条件に基づいて検索結果ページに移動するロジックを提供するカスタムフック
 *
 * @param {SelectedCurrentConditionType} selectedSearchCondition - 現在選択されている検索条件
 * @param {number} oldestDayWdtno - 検索条件に含まれる最古の日付の識別子
 * @returns {object} 検索ボタンおよび各種モーダルの検索ボタンのクリックハンドラを含むオブジェクト
 */
export const useSearch = (
  selectedSearchCondition: SelectedCurrentConditionType,
  oldestDayWdtno: number
) => {
  // サイドバー上での検索処理
  const onClickSearchButton = useCallback(() => {
    moveToSearchResultPage(selectedSearchCondition, oldestDayWdtno);
  }, [oldestDayWdtno, selectedSearchCondition]);

  // 職種モーダルでの検索処理
  const onClickOccupationModalSearchButton = useCallback(
    (selectedOccupation: {
      searchJobTypeLId: SelectedCurrentConditionType['searchJobTypeLId'];
      searchJobTypeMId: SelectedCurrentConditionType['searchJobTypeMId'];
      searchJobTypeSId: SelectedCurrentConditionType['searchJobTypeSId'];
    }) => {
      moveToSearchResultPage(
        { ...selectedSearchCondition, ...selectedOccupation },
        oldestDayWdtno
      );
    },
    [oldestDayWdtno, selectedSearchCondition]
  );

  // 勤務地モーダルでの検索処理
  const onClickLocationModalSearchButton = useCallback(
    (selectedLocation: {
      areaId: string[];
      prefectureId: string[];
      cityId: string[];
      wardId: string[];
    }) => {
      moveToSearchResultPage(
        { ...selectedSearchCondition, ...selectedLocation },
        oldestDayWdtno
      );
    },
    [oldestDayWdtno, selectedSearchCondition]
  );

  // 路線駅モーダルでの検索処理
  const onClickRouteStationModalSearchButton = useCallback(
    (selectedRouteStation: { routeId: string[]; stationId: string[] }) => {
      moveToSearchResultPage(
        { ...selectedSearchCondition, ...selectedRouteStation },
        oldestDayWdtno
      );
    },
    [oldestDayWdtno, selectedSearchCondition]
  );

  // 業種モーダルでの検索処理
  const onClickIndustryModalSearchButton = useCallback(
    (selectedIndustry: { industryLId: string[]; industrySId: string[] }) => {
      moveToSearchResultPage(
        {
          ...selectedSearchCondition,
          ...selectedIndustry,
        },
        oldestDayWdtno
      );
    },
    [oldestDayWdtno, selectedSearchCondition]
  );

  return {
    onClickSearchButton,
    onClickOccupationModalSearchButton,
    onClickLocationModalSearchButton,
    onClickRouteStationModalSearchButton,
    onClickIndustryModalSearchButton,
  };
};
